import React, { useEffect, useState } from "react";
import "../../styles.scss";
import profileImg from "../../assets/globalImgs/profile.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import useHandleErrors from "../../utils/user.utils";
import Select from 'react-select';

const OffboardEmployee = () => {
    const [empId, setEmpId] = useState("");
    const [employeeData, setEmployeeData] = useState({});
    const [loading, setLoading] = useState(false);
    const [offboardData, setOffboardData] = useState({
        EmployeeResignation: "",
        ManagerEmail: "",
        NoticePeriodDays: "",
        DateOfLeaving: "",
        Comments: "",
    });
    const handleErrors = useHandleErrors();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({
        dateOfLeavingError: "",
    });
    const token = localStorage.getItem("token");
    const handleDateOfLeavingChange = (event) => {
        const selectedDate = new Date(event.target.value);
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Ensure the comparison ignores time parts

        // if (selectedDate <= today) {
        //     setErrors((prevErrors) => ({
        //         ...prevErrors,
        //         dateOfLeavingError:
        //             "Last Working Date must be greater than today's date",
        //     }));
        // } else {
        //     setErrors((prevErrors) => ({
        //         ...prevErrors,
        //         dateOfLeavingError: "",
        //     }));
        // }

        setOffboardData((prevData) => ({
            ...prevData,
            DateOfLeaving: event.target.value,
        }));
    };

    useEffect(() => {
        const fetchEmployeeData = async () => {
            if (empId) {
                setLoading(true);
                try {
                    const path = `/getOnboardEmployeeDetails?EmployeeId=${empId}`;
                    const URL = process.env.REACT_APP_BE_URL + path;
                    const response = await axios.get(URL, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    if (response.status === 200) {
                        setEmployeeData(response.data);
                    } else {
                        handleErrors(response)
                    }
                } catch (error) {
                    if (error.response) {
                        handleErrors(error.response);
                    } else {
                        toast.error("Something went wrong. Please try again later.", {
                            position: toast.POSITION.TOP_CENTER,
                        });
                    }
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchEmployeeData();
    }, [empId]);

    const handleSearchClick = () => {
        const inputEmpId = document.getElementById("empIdInput").value;
        setEmpId(inputEmpId);
    };

    const handleNext = async (event) => {
        event.preventDefault();
        setLoading(true);
        if (!empId) {
            toast.error("Please enter EmployeeId", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);
        }
        if (!offboardData.EmployeeResignation) {
            toast.error("Please enter EmployeeResignation", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);
        }
        if (!offboardData.NoticePeriodDays && !employeeData.NoticePeriod) {
            toast.error("Please enter Notice Period Days", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);
        }
        if (!offboardData.DateOfLeaving) {
            toast.error("Please enter Last Working Date", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);
        }
        try {
            const path = "/updateOffboardEmployee";
            const URL = process.env.REACT_APP_BE_URL + path;
            const updatedOffboardData = {
                ...offboardData,
                EmployeeId: empId,
                ManagerEmail: employeeData?.ManagerEmail
            };
            const response = await axios.put(URL,
                updatedOffboardData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response.status === 200) {
                localStorage.setItem('empId', empId);
                toast.success("Employee offboarded successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                navigate("/assethandover");
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handlePrevious = () => {
        setEmpId('');
        setEmployeeData({});
        setOffboardData({
            EmployeeResignation: '',
            ManagerEmail: '',
            NoticePeriodDays: '',
            DateOfLeaving: '',
            Comments: '',
        });
    };

    const resignOptions = [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" }
    ];

    const ClearIndicator = () => null;

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div class="content-page">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col">
                            <h3 class="title mb-2">Offboard Employee</h3>
                        </div>
                        <div class="col-auto">
                            <Link
                                to={'/Employees'}
                                data-extra-toggle="tab"
                                data-target="#organisation-pan"
                                class="btn btn-primary mt-lg-0 mt-4"
                            >
                                <i class="ri-user-star-line"></i> View All Employees
                            </Link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-1">
                            <div class="circle-tab-wrapper">
                                <ul class="nav nav-tabs circle-tab" role="tablist">
                                    <li class="nav-item step-done">
                                        <a
                                            class="nav-link active"
                                            data-toggle="tab"
                                            to={'/offboardemployee'}
                                            title="Employee Information"
                                            rel="tooltip"
                                            role="tab"
                                        >
                                            <i class="ri-user-received-line"></i>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            class="nav-link"
                                            // data-toggle="tab"
                                            title="Asset Handover"
                                            rel="tooltip"
                                            role="tab"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <i class="ri-hand-coin-line"></i>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            class="nav-link"
                                            // data-toggle="tab"
                                            title="Settlement"
                                            rel="tooltip"
                                            role="tab"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <i class="ri-shake-hands-line"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-11">
                            <div
                                class="tab-pane active"
                                id="offbboard-employee-form"
                                role="tabpanel"
                            >
                                <div class="row">
                                    <div class="col-lg-4">
                                        <div class="card mb-4">
                                            <div class="card-body">
                                                <h5 class="title">Employee Information</h5>
                                                <div class="container-fluid row-rounded">
                                                    <div class="row px-2 py-0">
                                                        <div class="input-group mb-0">
                                                            <input
                                                                type="search"
                                                                class="form-control search-input"
                                                                //value={empId}
                                                                //onChange={handleSearch}
                                                                id="empIdInput"
                                                            />
                                                            <div class="input-group-append">
                                                                <button
                                                                    class="btn btn-primary"
                                                                    type="button"
                                                                    title="Search"
                                                                    rel="tooltip"
                                                                    onClick={handleSearchClick}
                                                                >
                                                                    <i class="ri-user-search-line"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {employeeData && (
                                                    <div class="user-info">
                                                        <div class="profile-detail">
                                                            <div class="user-profile-pic">
                                                                <img src={employeeData?.Image ? employeeData?.Image : profileImg} class="img-fluid" />
                                                            </div>
                                                        </div>
                                                        <div class="text-center mt-3 mb-4">
                                                            <h6>{employeeData?.FirstName} {employeeData?.MiddleName} {employeeData?.LastName}</h6>
                                                        </div>
                                                    </div>
                                                )}
                                                <div class="row mt-3">
                                                    <div class="form-group col-md-6 col-lg-12 col-sm-6">
                                                        <small class="form-text text-muted mb-2" for="oeEmail">Official Email</small>
                                                        <h6>{employeeData?.OfficialEmail}</h6>
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-12 col-sm-6">
                                                        <small class="form-text text-muted mb-2" for="oeEmail">Personal Email</small>
                                                        <h6>{employeeData?.PersonalEmail}</h6>
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-12  col-sm-6">
                                                        <small class="form-text text-muted mb-2" for="contactNumber">Contact Number</small>
                                                        <h6>{employeeData?.ContactNumber}</h6>
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-6 col-sm-6">
                                                        <small class="form-text text-muted mb-2" for="userAccess">User Access</small>
                                                        <h6>{employeeData?.UserAccessLevel}</h6>
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-6 col-sm-6">
                                                        <small class="form-text text-muted mb-2" sm for="employeeType">Employment Type</small>
                                                        <h6>{employeeData?.EmployeeType}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-8">
                                        <div class="card mb-4">
                                            <div class="card-body">
                                                <h5 class="title">Offboard Information </h5>
                                                <div class="row mt-4">
                                                    <div class="form-group col-md-6">
                                                        <label for="employeerRsignation" class="required">
                                                            Employee Self Resignation
                                                        </label>
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name="EmployeeResignation"
                                                            value={
                                                                resignOptions.find(
                                                                    (option) =>
                                                                        option.value === offboardData.EmployeeResignation
                                                                ) || null
                                                            }
                                                            onChange={(selectedOption) =>
                                                                setOffboardData({
                                                                    ...offboardData,
                                                                    EmployeeResignation: selectedOption
                                                                        ? selectedOption.value
                                                                        : "",
                                                                })
                                                            }
                                                            options={resignOptions}
                                                            components={{ ClearIndicator }}
                                                            isClearable
                                                            menuPortalTarget={document.body}
                                                        />
                                                    </div>
                                                    <div class="form-group col-md-6">
                                                        <label for="ManagerEmail" class="required">Manager Email</label>
                                                        <input
                                                            type="email"
                                                            class="form-control"
                                                            value={employeeData?.ManagerEmail}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div class="form-group col-md-6">
                                                        <label for="NoticePeriodDays" class="required">Notice Period <small>(Days)</small></label>
                                                        <input
                                                            type="number"
                                                            class="form-control"
                                                            value={offboardData.NoticePeriodDays?offboardData.NoticePeriodDays:employeeData.noticePeriod}
                                                            onChange={(event) =>
                                                                setOffboardData({
                                                                    ...offboardData,
                                                                    NoticePeriodDays: event.target.value,
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                    <div class="form-group col-md-6">
                                                        <label for="DateOfLeaving" class="required">Last Working Date</label>
                                                        <input
                                                            type="date"
                                                            className={`form-control ${errors.dateOfLeavingError ? "is-invalid" : ""
                                                                }`}
                                                            value={offboardData.DateOfLeaving}
                                                            onChange={handleDateOfLeavingChange}
                                                        />
                                                        {errors.dateOfLeavingError && (
                                                            <div className="invalid-feedback">
                                                                {errors.dateOfLeavingError}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div class="form-group col-md-12">
                                                        <label for="Comments">Comments</label>
                                                        <textarea
                                                            class="form-control"
                                                            rows="7"
                                                            onChange={(event) =>
                                                                setOffboardData({
                                                                    ...offboardData,
                                                                    Comments: event.target.value,
                                                                })
                                                            }>
                                                        </textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row fixed-footer">
                <div class="col-lg-12 text-center OFFBfirstTab">
                    <button class="btn btn-light" type="reset" onClick={handlePrevious}>Cancel</button>
                    <button class="btn btn-primary btnNext" type="button" onClick={handleNext}>Next <i class="ri-arrow-right-circle-line"></i></button>
                </div>
            </div>
        </div>
    );
}

export default OffboardEmployee;